import React from 'react';

const Certificate = ({ className }) => (
  <svg
    className={className}
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 0C1.46957 0 0.960859 0.210713 0.585786 0.585786C0.210713 0.960859 0 1.46957 0 2V9.99999C0 10.5304 0.210713 11.0391 0.585786 11.4142C0.960859 11.7893 1.46957 12 2 12H9.49999V11.329C9.4144 11.223 9.33366 11.1133 9.25799 11H2C1.73478 11 1.48043 10.8946 1.29289 10.7071C1.10536 10.5196 0.999999 10.2652 0.999999 9.99999V2C0.999999 1.73478 1.10536 1.48043 1.29289 1.29289C1.48043 1.10536 1.73478 0.999999 2 0.999999H14C14.2652 0.999999 14.5196 1.10536 14.7071 1.29289C14.8946 1.48043 15 1.73478 15 2V4.468C15.364 4.648 15.7 4.878 16 5.146V2C16 1.46957 15.7893 0.960859 15.4142 0.585786C15.0391 0.210713 14.5304 0 14 0H2Z"
      fill="white"
      fillOpacity="0.5"
    />
    <path
      d="M16.5 8.5C16.5 9.42826 16.1312 10.3185 15.4749 10.9749C14.8185 11.6312 13.9283 12 13 12C12.0717 12 11.1815 11.6312 10.5251 10.9749C9.86875 10.3185 9.5 9.42826 9.5 8.5C9.5 7.57174 9.86875 6.6815 10.5251 6.02513C11.1815 5.36875 12.0717 5 13 5C13.9283 5 14.8185 5.36875 15.4749 6.02513C16.1312 6.6815 16.5 7.57174 16.5 8.5Z"
      fill="white"
      fillOpacity="0.5"
    />
    <path
      d="M13 13C13.925 13 14.785 12.72 15.5 12.242V15C15.5 15.0929 15.4741 15.1839 15.4253 15.2629C15.3765 15.3419 15.3067 15.4057 15.2236 15.4472C15.1406 15.4887 15.0476 15.5063 14.9551 15.498C14.8626 15.4896 14.7743 15.4557 14.7 15.4L13.3 14.35C13.2135 14.2851 13.1082 14.25 13 14.25C12.8918 14.25 12.7865 14.2851 12.7 14.35L11.3 15.4C11.2257 15.4557 11.1374 15.4896 11.0449 15.498C10.9524 15.5063 10.8594 15.4887 10.7764 15.4472C10.6933 15.4057 10.6235 15.3419 10.5747 15.2629C10.5259 15.1839 10.5 15.0929 10.5 15V12.242C11.2395 12.7375 12.1098 13.0014 13 13Z"
      fill="white"
      fillOpacity="0.5"
    />
    <path
      d="M3 3.5C3 3.36739 3.05268 3.24021 3.14645 3.14645C3.24021 3.05268 3.36739 3 3.5 3H12.5C12.6326 3 12.7598 3.05268 12.8535 3.14645C12.9473 3.24021 13 3.36739 13 3.5C13 3.63261 12.9473 3.75978 12.8535 3.85355C12.7598 3.94732 12.6326 4 12.5 4H3.5C3.36739 4 3.24021 3.94732 3.14645 3.85355C3.05268 3.75978 3 3.63261 3 3.5Z"
      fill="white"
      fillOpacity="0.5"
    />
    <path
      d="M3.5 8C3.36739 8 3.24021 8.05268 3.14645 8.14645C3.05268 8.24021 3 8.36739 3 8.5C3 8.63261 3.05268 8.75979 3.14645 8.85355C3.24021 8.94732 3.36739 9 3.5 9H7.5C7.63261 9 7.75978 8.94732 7.85355 8.85355C7.94732 8.75979 8 8.63261 8 8.5C8 8.36739 7.94732 8.24021 7.85355 8.14645C7.75978 8.05268 7.63261 8 7.5 8H3.5Z"
      fill="white"
      fillOpacity="0.5"
    />
  </svg>
);

export default Certificate;
